export default __webpack_public_path__ + "560ee261e4889e084fcff4d3df8c7813.svg";